// WS plugin for predicate-rule invalidation. The chores server
// emits 'predicate_rule_changed' on every successful PutRule;
// clients react by re-pulling immediately rather than waiting
// for the 5-min poll loop.

import type { WsPluginMap } from '@/infra/ws/root-saga';
import { predicateBoot } from './sagas';

export const predicateWsPlugin: WsPluginMap = {
  // Server emits the canonical chores event-type pattern: <module>.<verb>.
  // We register both the underscored form (server's current shape) and
  // the dotted form so a future migration to dotted naming on the
  // chores side doesn't silently break the client.
  predicate_rule_changed: () => ({ ...predicateBoot(), payload: undefined }),
  'predicate.rule.changed': () => ({ ...predicateBoot(), payload: undefined }),
};
